"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _IconArrowDown = _interopRequireDefault(require("./IconArrowDown"));
var IconArrowLeft = /*#__PURE__*/(0, _styledComponents.default)(_IconArrowDown.default).withConfig({
  displayName: "IconArrowLeft",
  componentId: "c11n-8-107-0__sc-mqj5dh-0"
})(["transform:rotate(90deg);"]);
var _default = IconArrowLeft;
exports.default = _default;